module.exports = __webpack_public_path__ + "static/media/clinica-a-s-new.47493acf.jpg";